import React from 'react';

interface Props {
  children: React.ReactNode;
  head?: boolean;
  className?: string;
  colSpan?: number;
}

export default function TableCell({ children, head = false, className = '', colSpan }: Props): JSX.Element {
  if (head) {
    return <th className={`app-table__th ${className}`}>{children}</th>;
  }

  return (
    <td className={`app-table__td ${className}`} colSpan={colSpan}>
      {children}
    </td>
  );
}
